import React from "react";

function renderInline(text, keyBase) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={`${keyBase}-${i}`} className="font-semibold text-foreground">
        {p.slice(2, -2)}
      </strong>
    ) : (
      <React.Fragment key={`${keyBase}-${i}`}>{p}</React.Fragment>
    )
  );
}

export function TermsMarkdown({ source, compact = false }) {
  const lines = source.split("\n");
  const blocks = [];
  let list = null;
  const body = compact ? "mt-1.5 text-xs leading-relaxed text-muted-foreground" : "mt-2 text-sm leading-relaxed text-muted-foreground";
  const h2 = compact
    ? "mt-4 font-display text-sm font-bold tracking-tight text-foreground"
    : "mt-8 font-display text-lg font-bold tracking-tight text-foreground";
  const h1 = compact
    ? "font-display text-base font-bold tracking-tight text-foreground"
    : "font-display text-3xl font-bold tracking-tight text-foreground lg:text-4xl";
  const ul = compact
    ? "my-2 list-disc space-y-1 pl-5 text-xs text-muted-foreground"
    : "my-3 list-disc space-y-1.5 pl-6 text-sm text-muted-foreground";

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (line.startsWith("- ")) {
      if (!list) list = [];
      list.push(line.slice(2));
      return;
    }
    if (list) {
      blocks.push(
        <ul key={`ul-${idx}`} className={ul}>
          {list.map((li, i) => (
            <li key={i}>{renderInline(li, `li-${idx}-${i}`)}</li>
          ))}
        </ul>
      );
      list = null;
    }
    if (line === "") return;
    if (line.startsWith("# ")) {
      blocks.push(
        <h1 key={idx} className={h1}>
          {line.slice(2)}
        </h1>
      );
    } else if (line.startsWith("## ")) {
      blocks.push(
        <h2 key={idx} className={h2}>
          {line.slice(3)}
        </h2>
      );
    } else {
      blocks.push(
        <p key={idx} className={body}>
          {renderInline(line, `p-${idx}`)}
        </p>
      );
    }
  });
  if (list) {
    blocks.push(
      <ul key="ul-end" className={ul}>
        {list.map((li, i) => (
          <li key={i}>{renderInline(li, `li-end-${i}`)}</li>
        ))}
      </ul>
    );
  }
  return <>{blocks}</>;
}
